import React from "react";
import { Link } from "react-router-dom";
import SectionHeading from "../components/SectionHeading";
import { shopProduct } from "../data/siteData";

const Shop = () => {
  return (
    <div>
      <section className="bg-p3-cream py-16">
        <div className="max-w-4xl mx-auto px-5 text-center">
          <h1 className="font-heading font-extrabold text-4xl text-p3-navy mb-3">Shop</h1>
          <p className="text-p3-muted">Browse our services and add them to your cart.</p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-5 lg:px-8">
          <SectionHeading eyebrow={shopProduct.category} title="Available Services" />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <Link
              to={`/shop/${shopProduct.slug}`}
              className="group bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden"
            >
              <div className="h-48 flex items-center justify-center bg-p3-cream p-8">
                <img src={shopProduct.image} alt={shopProduct.name} className="h-full object-contain" />
              </div>
              <div className="p-6">
                <p className="text-xs uppercase font-semibold text-p3-gold mb-1">{shopProduct.category}</p>
                <h3 className="font-heading font-bold text-lg text-p3-navy mb-2 group-hover:text-p3-blue transition-colors">
                  {shopProduct.name}
                </h3>
                <p className="text-sm text-p3-muted mb-3">
                  ${shopProduct.minPrice.toFixed(2)} &ndash; ${shopProduct.maxPrice.toFixed(2)}
                </p>
                <span className="inline-block text-sm font-semibold text-p3-blue">Select options &rarr;</span>
              </div>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Shop;
